/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState } from "react";
import * as styles from "./GalleryBanner.module.css";
import galleryBanner from "../../../images/on-going-projects/enchanted/Images/North-West-Corner-Part-Aerial-View-Image.jpg";
import towerViewImage from "../../../images/on-going-projects/enchanted/Icons/tower-view-image.png";
import canUseDom from "../../utils/canUseDom";

function GalleryBanner() {
  const [isAnimated, setIsAnimated] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);
  const bannerImageRef = useRef(null);
  const observerRef = useRef(null);

  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setIsAnimated(true);
      }
    });
  };

  useEffect(() => {
    if (canUseDom && bannerImageRef.current && typeof IntersectionObserver !== 'undefined') {
      const threshold = windowWidth > 1024 ? 0.7 : windowWidth > 768 ? 0.4 : 0.1;
      
      observerRef.current = new IntersectionObserver(handleIntersection, {
        threshold: threshold,
      });
      
      observerRef.current.observe(bannerImageRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [windowWidth]);

  useEffect(() => {
    if (canUseDom) {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
      
      // Set initial width
      setWindowWidth(window.innerWidth);
      
      // Add event listener
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return (
    <>
      <div className={styles.galleryBanner} id="gallery-banner">
        <img loading="lazy"  src={galleryBanner} ref={bannerImageRef} alt="large-pillar" />
        <div
          className={`${styles.galleryBannerContent} ${
            isAnimated ? styles.animated : ""
          }`}
        >
          <div className={styles.text}>OCEANFRONT</div>
          <div className={styles.text}>HOMES</div>
          <div className={styles.text}>ENGULFED</div>
          <div className={styles.text}>
            <span>BY</span>
            PRIVATE
          </div>
          <div className={styles.text}>OUTDOOR</div>
          <div className={styles.text}>SANCTUARIES</div>
        </div>
      </div>

      <div className={styles.towerViewSection}>
        <div className={styles.towerViewSectionTitle}>
          <span>45 DEGREE PIVOTED</span>
          <span>MULTI-STOREY TOWERS WITH</span>
          <span>ASSURED OCEAN VIEWS</span>
        </div>
        <div className={styles.towerViewSectionImageContainer}>
          <img loading="lazy"  src={towerViewImage} alt="tower-view" />
        </div>
        <div className={styles.towerViewSectionContent}>
          The multi-storey towers are strategically positioned to usher abundant
          natural air and sunlight. Apartments are rotated and stationed at a 45
          degree angle with assured, breath-taking views of the coastline. The
          vertical circulation planning ensures continuous access to ample
          natural lighting and cross-ventilation.
        </div>
      </div>
    </>
  );
}

export default GalleryBanner;
